import React from "react";

import ModalContainer from "../ModalContainer";

import { useDispatch, useSelector } from "react-redux";
import ActiveTableSelector from "../../../pages/OrderDashboard/RightPortion/ActiveTableSelector2";

import {
  changeItemQuantityRedux,
  checkIfQuantityExceeds,
  isThatItemInMyOrder,
  pushItemToActiveOrderRedux,
  removeItemRedux,
} from "../../../redux/reducers/newOrderReducer";

import getOrderNeccesaryData from "../../../helpers/getOrderNeccesaryData";
import moment from "moment";
import { CURRENCY, DATETIMEFORMAT, ITEMSTATUS } from "../../../contants";
import calculateOrderTotals from "../../../helpers/calculateOrderTotals";
import flattentItemsArray from "../../../helpers/flattenItemsArray";
import roundOffTotal from "../../../helpers/roundOffTotal";
import { generateInvoiceHtml } from "../../../helpers/generateTemplate";

const EditOrderModal = ({
  open,
  onClose,
  data: orderData,
  onSubmit,
  mode,
  onPrint,
}) => {
  const isViewMode = mode === "View";
  const ready = getOrderNeccesaryData();

  const [customerName, setCustomerName] = React.useState("");
  const [customerMobile, setCustomerMobile] = React.useState("");

  const isLoading = useSelector((state) => state.util.spinner);
  const [activeOrders, setActiveOrders] = React.useState([]);
  const [editRemarks, setEditRemarks] = React.useState(undefined);

  const handleChangeRemarks = (e) => {
    const {
      target: { value },
    } = e;

    setEditRemarks(value);
  };
  const [activeOldOrders, setActiveOldOrders] = React.useState([]);

  const { allItems } = useSelector((state) => state.order);
  const userData = useSelector((state) => state.user);
  const {
    enablePrinting,
    lowerRoundOff,
    upperRoundOff,
    standardRoundOff,
    exclusiveGST,
  } = useSelector((state) => state.util);
  const roundOffType = lowerRoundOff
    ? "lowerRoundOff"
    : upperRoundOff
      ? "upperRoundOff"
      : "standardRoundOff";

  const activeOrder = activeOrders[0];
  const activeOldOrder = activeOldOrders[0];
  const formatData = (data) => {
    const orderItems = data.orderItems;

    return {
      ...data,
      tablePrice: data?.tablePrice || 0,
      orderItems: orderItems,
      orderType: data.orderType,
      ...(mode === "EditOrder" && { isEdited: true }),
    };
  };

  React.useEffect(() => {
    if (open && activeOrder) {
      setCustomerName(activeOrder.customerName || "");
      setCustomerMobile(activeOrder.customerMobile || "");
    }
  }, [open, activeOrder]);

  // Update activeOrders when customer info changes
  const handleCustomerNameChange = (e) => {
    setCustomerName(e.target.value);
    setActiveOrders([
      {
        ...activeOrder,
        customerName: e.target.value,
      },
    ]);
  };

  const handleCustomerMobileChange = (e) => {
    setCustomerMobile(e.target.value);
    setActiveOrders([
      {
        ...activeOrder,
        customerMobile: e.target.value,
      },
    ]);
  };

  const findTableType = (tableNumber) => {
    switch (true) {
      case tableNumber?.includes("A"):
        return "AC";
      case tableNumber?.includes("N"):
        return "Non AC";
      case tableNumber?.includes("G"):
        return "Garden";
      case tableNumber?.includes("O"):
        return "Online";
      case tableNumber?.includes("H"):
        return "Hut";
      case tableNumber?.includes("R"):
        return "Room Service";
      case tableNumber?.includes("B"):
        return "Banquet Hall";
      default:
        return "default";
    }
  };

  const handleItemQuantity = ({ quantity, itemId, index, item }) => {
    // dispatch(changeItemQuantity(parseInt(quantity), itemindex));
    setActiveOrders([
      ...changeItemQuantityRedux({
        activeOrders,
        refId: activeOrder.refId,
        quantity: quantity,
        itemId: item.id,
        index,
      }),
    ]);
  };

  const deleteItem = (item, kotNumber, index) => {
    // dispatch(removeItem(index));
    if (activeOrder.orderItems.length < 2) {
      alert("Can not remove only item from the order");
    } else {
      setActiveOrders([
        ...removeItemRedux({
          activeOrders,
          refId: activeOrder.refId,

          itemId: item.itemId || item.id || item._id,
          index,
        }),
      ]);
    }
  };

  const handleSearchAndAddItem = (selected) => {
    if (selected.length > 0) {
      const item = selected[0];
      const isVariant = item?.isVariant ? true : false;
      const refId = activeOrder.refId;
      const kotIndex = activeOrder.KOTS.length - 1;

      const itemId = item?.variantId || item?.id || item?.id;

      const currItem = isThatItemInMyOrder(activeOrder, itemId, kotIndex);
      if (currItem) {
        if (checkIfQuantityExceeds(currItem, currItem.quantity + 1)) {
          return null;
        }
        setActiveOrders([
          ...changeItemQuantityRedux({
            activeOrders,
            refId: refId,
            quantity: parseInt(currItem.quantity),
            itemId,
            index: kotIndex,
          }),
        ]);
      } else {
        if (checkIfQuantityExceeds(item, 1)) {
          return null;
        }

        const netItem = {
          ...item,
          itemId: item?.variantId || item?._id || item?.id,
          isVariant: isVariant,
          quantity: 1,

          itemTotal: 1 * item.itemPrice,
          itemStatus: ITEMSTATUS[0].key,
          itemStatusId: ITEMSTATUS[0].value,
          kotQuantity: 0,
          kotTotal: 0,
        };

        setActiveOrders([
          ...pushItemToActiveOrderRedux({
            activeOrders,
            refId: activeOrder.refId,
            item: netItem,
          }),
        ]);
      }
    }
  };

  React.useEffect(() => {
    if (open) {
      const myData = formatData(orderData);

      setActiveOrders([myData]);
      if (myData?.oldOrder) {
        const emyData = formatData(orderData.oldOrder);

        setActiveOldOrders([emyData]);
      }
    }
  }, [open]);

  const getData = (orderData) => {
    let mydata = orderData || activeOrder;
    let tableType = findTableType(mydata.tableNumber);
    return mydata
      ? calculateOrderTotals(
          mydata,
          mydata?.cgst,
          mydata?.sgst,
          mydata?.otherCharges,
          mydata?.discount,
          tableType,
          exclusiveGST,
        )
      : {};
  };

  const bottomTableData = (varData) => [
    [
      {
        value: "Order Date : ",
      },
      {
        value: moment(varData.updatedAt).format(DATETIMEFORMAT),
      },
      {
        value: "Sub Total : ",
      },
      {
        value: getData(varData).subTotal?.toFixed(2),
        isCurrency: true,
      },
    ],
    [
      {
        value: "User : ",
      },
      {
        value: varData?.orderBy,
      },
      {
        value: "Discount : ",
      },
      {
        value: varData?.discount,
        isCurrency: true,
      },
    ],
    [
      {
        value: "Payment : ",
      },
      {
        value: varData?.paymentType,
      },
      {
        value: "GST : ",
      },
      {
        renderTd: (row) => (
          <td>
            {CURRENCY}
            {(
              getData(varData).sgstCharges + getData(varData).cgstCharges
            ).toFixed(2)}
          </td>
        ),
        isCurrency: true,
      },
    ],
    [
      {
        value: "Customer Name : ",
      },
      {
        value: varData?.customerName,
      },
      {
        value: "Charges : ",
      },
      {
        value: getData(varData)?.otherCharges,
        isCurrency: true,
      },
    ],
    [
      {
        value: "Mobile Number : ",
      },
      {
        value: varData?.customerMobile,
      },
      {
        value: "Grand Total : ",
        renderTd: (row) => (
          <td>
            <strong>Grand Total : </strong>
          </td>
        ),
      },
      {
        renderTd: (row) => (
          <td>
            <strong>
              {CURRENCY}
              {roundOffTotal(getData(varData)?.grandTotal, roundOffType)}
            </strong>
          </td>
        ),

        isCurrency: true,
      },
    ],
  ];

  const handleDownload = async (activeOrder) => {
    let logoData = null;
    const rawLogo = userData?.logo || null;
    if (rawLogo) {
      try {
        // SSRF Protection: Ensure logo is only fetched from allowed domains or relative paths
        let imageUrl = null;
        if (rawLogo.startsWith("http://") || rawLogo.startsWith("https://")) {
          const urlObj = new URL(rawLogo);
          const allowedDomains = ["test.mealbill.in", "mealbill.in"]; // Add any trusted S3/storage domains here
          if (
            allowedDomains.some((domain) => urlObj.hostname.endsWith(domain))
          ) {
            imageUrl = rawLogo;
          } else {
            console.warn(
              "SSRF Blocked: Unapproved logo domain",
              urlObj.hostname,
            );
          }
        } else {
          const cleanLogo = rawLogo.startsWith("./")
            ? rawLogo.substring(1)
            : rawLogo;
          imageUrl = `https://test.mealbill.in/${cleanLogo}`;
        }

        if (imageUrl) {
          const logoRes = await fetch(imageUrl);
          if (logoRes.ok) {
            const buffer = await logoRes.arrayBuffer();
            const contentType =
              logoRes.headers.get("content-type") || "image/jpeg";
            logoData = `data:${contentType};base64,${Buffer.from(buffer).toString("base64")}`;
          }
        }
      } catch (e) {
        console.error("Failed to fetch logo on server", e);
      }
    }
    const freshData = getData(activeOrder);
    const totals = {
      subTotal: freshData.subTotal || 0,
      taxTotal: freshData.taxTotal || 0,
      otherCharges: freshData.otherCharges || 0,
      discount: freshData.discount || 0,
      grandTotal: freshData.grandTotal || 0,
    };
    const user = {
      restaurantName: activeOrder?.restaurant?.name || "MealBill Restaurant",
      branchName: activeOrder?.branch?.name || "",
      branchAddress:
        activeOrder?.branch?.address || activeOrder?.restaurant?.address || "",
      fssaiNumber:
        activeOrder?.branch?.fssaiNumber ||
        activeOrder?.restaurant?.fssaiNumber ||
        "",
      gstNumber: userData?.gstNumber || "",
      logo: logoData, // Pass the base64 directly
      phone: activeOrder?.branch?.phone || activeOrder?.restaurant?.phone || "",
      email: activeOrder?.branch?.email || activeOrder?.restaurant?.email || "",
      receiptMessage: "Thank you for dining with us!",
    };

    const htmlContent = generateInvoiceHtml(
      activeOrder,
      totals,
      user,
      exclusiveGST,
      roundOffType,
    );
    const fileName = `Invoice_${activeOrder?.branchOrderNumber || activeOrder?.orderNumber || "N/A"}.pdf`;

    let container = null;

    const originalGetComputedStyle = window.getComputedStyle;
    window.getComputedStyle = function (el, pseudoElt) {
      const style = originalGetComputedStyle(el, pseudoElt);
      return new Proxy(style, {
        get(target, prop) {
          if (prop === "getPropertyValue") {
            return function (propName) {
              const val = target.getPropertyValue(propName);
              if (val && (val.includes("oklch") || val.includes("lab"))) {
                return "rgba(0, 0, 0, 0)";
              }
              return val;
            };
          }
          const val = target[prop];
          if (
            typeof val === "string" &&
            (val.includes("oklch") || val.includes("lab"))
          ) {
            return "rgba(0, 0, 0, 0)";
          }
          if (typeof val === "function") {
            return val.bind(target);
          }
          return val;
        },
      });
    };

    try {
      // @ts-ignore
      const html2pdf = (await import("html2pdf.js")).default;

      container = document.createElement("div");
      container.style.cssText =
        "position:absolute;left:-9999px;top:0;width:148mm;overflow:hidden;pointer-events:none;z-index:-9999;";
      container.innerHTML = htmlContent;
      document.body.appendChild(container);

      const element =
        container.querySelector(".invoice-container") || container;

      const images = container.querySelectorAll("img");
      await Promise.all(
        Array.from(images).map(
          (img) =>
            new Promise(async (resolve) => {
              if (img.src && img.src.startsWith("http")) {
                try {
                  const response = await fetch(img.src);
                  const blob = await response.blob();
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    img.src = reader.result;
                    resolve();
                  };
                  reader.readAsDataURL(blob);
                } catch (e) {
                  console.error("Failed to convert image to base64", e);
                  resolve();
                }
              } else if (img.complete) {
                resolve();
              } else {
                img.onload = () => resolve();
                img.onerror = () => resolve();
              }
            }),
        ),
      );

      await new Promise((r) => setTimeout(r, 100));

      const opt = {
        margin: 0,
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          scrollX: 0,
          scrollY: 0,
          backgroundColor: "#ffffff",
        },
        jsPDF: {
          unit: "mm",
          format: "a5",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["css", "legacy"],
        },
      };

      const pdfWorker = html2pdf().set(opt).from(element);
      const pdfBlob = await pdfWorker.outputPdf("blob");

      if (container && container.parentNode) {
        document.body.removeChild(container);
        container = null;
      }

      const blobUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      link.click();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (err) {
      console.error("PDF generation failed:", err);
      if (container && container.parentNode) {
        document.body.removeChild(container);
      }
    } finally {
      window.getComputedStyle = originalGetComputedStyle;
    }
  };

  return (
    <div>
      <ModalContainer
        open={open}
        onClose={() => {
          onClose();
          // setFormErrors();
          // reset();
        }}
        title={`Order : # ${activeOrder?.branchOrderNumber}`}
        // title={`${mode} ${title}`}
        size={activeOldOrder ? "xl" : "md"}
      >
        <div className="row">
          {activeOldOrder && (
            <div className="col-md-6">
              <h5>Old Order </h5>

              <ActiveTableSelector
                tables={activeOldOrders}
                activeOrdersLength={1}
                scrollable
                orderDeletable={false}
                active={activeOldOrder}
                handleItemQuantity={() => {}}
                deleteItem={() => {}}
                handleSearchAndAddItem={() => {}}
                allItems={flattentItemsArray(allItems)}
                disabled={true}
                hideSearch={true}
                makeTableActive={() => {}}
                isEditMode
                tableType={findTableType(activeOrder?.tableNumber)}
              />
              <BottomTable tableData={bottomTableData(activeOldOrder)} />
            </div>
          )}

          {activeOrders.length > 0 && (
            <div className={activeOldOrder ? "col-md-6" : "col-md-12"}>
              {activeOldOrder && <h5>Current Order </h5>}

              <ActiveTableSelector
                tables={activeOrders}
                activeOrdersLength={1}
                scrollable
                orderDeletable={false}
                active={activeOrder}
                handleItemQuantity={handleItemQuantity}
                deleteItem={deleteItem}
                handleSearchAndAddItem={handleSearchAndAddItem}
                allItems={flattentItemsArray(allItems)}
                disabled={
                  activeOldOrder || isViewMode || activeOrder?.editCount >= 1
                }
                hideSearch={isViewMode}
                makeTableActive={() => {}}
                isEditMode
                tableType={findTableType(activeOrder?.tableNumber)}
              />

              <div className="form-group row">
                <div className="col-md-6">
                  <label>Customer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={customerName}
                    onChange={handleCustomerNameChange}
                    disabled={isViewMode}
                    placeholder="Enter customer name"
                  />
                </div>
                <div className="col-md-6">
                  <label>Customer Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    value={customerMobile}
                    onChange={handleCustomerMobileChange}
                    disabled={isViewMode}
                    placeholder="Enter mobile number"
                  />
                </div>
              </div>

              <BottomTable tableData={bottomTableData(activeOrder)} />
            </div>
          )}
        </div>
        <div className="form-group mt-3 mb-3">
          <div className={`form-group col-md-${"12"}`}>
            <label>Remarks</label>
            <textarea
              type="text"
              className="form-control"
              placeholder={" Type Remarks"}
              rows={2}
              readOnly={activeOldOrder}
              value={editRemarks || activeOrder?.editRemarks}
              onChange={handleChangeRemarks}
            />
          </div>
        </div>
        <div className="form-group mb-0 mt-3 d-flex justify-content-center">
          {!isViewMode && activeOrder?.editCount < 1 && (
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-gradient-primary waves-effect waves-light"
              onClick={() => {
                onSubmit({
                  ...activeOrders[0],
                  editRemarks: editRemarks || activeOrder?.editRemarks,
                  ...getData(),
                });
              }}
            >
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              Submit
            </button>
          )}
          <button
            type="reset"
            className="btn btn-gradient-danger waves-effect ml-3"
            onClick={() => onClose()}
          >
            Close
          </button>
          {enablePrinting && (
            <button
              onClick={() => onPrint(activeOrder)}
              type="button"
              className="btn btn-outline-primary ml-3"
            >
              <i className={`dripicons-print mr-2`}></i>
              Print
            </button>
          )}
          <button
            onClick={() => handleDownload(activeOrder)}
            type="button"
            className="btn btn-outline-success ml-3"
          >
            <i className="dripicons-download mr-2"></i>
            Download
          </button>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditOrderModal;

const BottomTable = ({ tableData }) => {
  return (
    <div>
      <div className="table-responsive-sm">
        <table className="table table-sm mb-0">
          <tbody>
            {tableData.map((row, rowIndex) => {
              return (
                <tr>
                  {row.map((td) => {
                    if (td.renderTd) {
                      return td.renderTd();
                    }
                    return (
                      <td>
                        {" "}
                        {td.isCurrency ? CURRENCY : ""}
                        {td.value}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  paginated: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "0px 1vw",
    maxWidth: "20vw",
  },
  select: {
    margin: "0px 0.5vw",
  },
  searchGroup: {
    maxWidth: "15vw",
  },
};
